/** @jsx jsx */
import { jsx } from "@emotion/react";
import { ChangeEvent, FC } from "react";
import Option from "../../atoms/inputs/Option";
import { OptionData } from "./types";
import { selectCss } from "./styles";
import useSelectSizeToFitScreen from "./useSelectSizeToFitScreen";

const OptionListNoSearch: FC<Props> = ({
  options,
  onChangeOfActiveOptions,
  size,
  maxSize = 10,
  minSize = 5,
  className,
}) => {
  const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const activeOptions = [...e.target.options].filter((o) => o.selected);
    const activeOptionIds = activeOptions.map((o) => o.value);

    onChangeOfActiveOptions(new Set(activeOptionIds));
  };

  const updatedSize = useSelectSizeToFitScreen({
    optionsCount: options.length,
    size,
    minSize,
    maxSize,
  });

  return (
    <select
      css={selectCss}
      className={className}
      multiple
      size={updatedSize}
      onChange={handleSelectChange}
      data-cy="option-list-no-search"
    >
      {options.map(({ text, value }) => (
        <Option key={value} text={text} value={value} />
      ))}
    </select>
  );
};

type Props = {
  onChangeOfActiveOptions: (newActiveOptionValues: Set<string>) => void;
  options: OptionData[];
  size?: number;
  maxSize?: number;
  minSize?: number;
  className?: string;
};

export default OptionListNoSearch;
export type OptionListNoSearchProps = Props;
